import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './Accordion';
const faqData = [{
  id: 'faq-1',
  question: '¿Sirve si recién empecé la carrera?',
  answer: 'Sí. El Tomo 1 está diseñado para quienes están en primer año y no saben por dónde arrancar. El sistema funciona desde el día cero.'
}, {
  id: 'faq-2',
  question: '¿Está adaptado a universidades argentinas?',
  answer: '100%. Todo el contenido está basado en los planes de estudio de UBA, UNLP, UNC y universidades privadas argentinas, actualizado a 2026.'
}, {
  id: 'faq-3',
  question: '¿Cómo recibo el material?',
  answer: 'Acceso inmediato después del pago. Es digital — lo podés usar desde el celular, tablet o computadora. También podés imprimirlo.'
}, {
  id: 'faq-4',
  question: '¿Para qué año de la carrera sirve más?',
  answer: 'Para todos. Del primer año al último. Los tomos de organización sirven siempre, y los clínicos son especialmente útiles a partir de 3ro.'
}, {
  id: 'faq-5',
  question: '¿Qué diferencia hay entre los dos planes?',
  answer: 'Ambos incluyen los 6 tomos y los 4 bonos. El plan Completo agrega recursos adicionales para potenciar el estudio clínico.'
}, {
  id: 'faq-6',
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
}];
export function FAQ() {
  const accordionItems = faqData.map(faq => ({
    id: faq.id,
    title: <span className="text-white font-medium" data-id="element-59">{faq.question}</span>,
    content: <p className="text-gray-300 text-sm pt-2" data-id="element-60">{faq.answer}</p>
  }));
  return <section className="bg-brand-dark py-16 px-4 sm:px-6 lg:px-8" data-id="element-61">
      <div className="max-w-2xl mx-auto" data-id="element-62">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-bold text-center text-white mb-10" data-id="element-63">
          Lo que más nos preguntan
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-64">
          <Accordion items={accordionItems} className="space-y-3" data-id="element-65" />
        </motion.div>
      </div>
    </section>;
}